import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from './components/ui/dialog';
import { Button } from './components/ui/button';
import { Checkbox } from './components/ui/checkbox';
import { Table, TableHeader, TableBody, TableHead, TableRow, TableCell } from './components/ui/table';

const SplitShipmentModal = ({ open, onClose, shipmentItems, onSelectItems, onSplit }) => {
  const [selected, setSelected] = useState([]);

  // Handle selecting/deselecting all items
  const handleSelectAll = (checked) => {
    if (checked) {
      const newSelected = shipmentItems.map((item) => item.id);
      setSelected(newSelected);
      onSelectItems(shipmentItems); // Pass all items when selecting all
      return;
    }
    setSelected([]);
    onSelectItems([]); // Clear selection when deselecting all
  };

  // Handle selecting/deselecting a single item
  const handleSelectOne = (checked, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [...selected];

    if (checked && selectedIndex === -1) {
      newSelected.push(id);
    } else if (!checked && selectedIndex !== -1) {
      newSelected.splice(selectedIndex, 1);
    }

    setSelected(newSelected);
    onSelectItems(newSelected.map((id) => shipmentItems.find((item) => item.id === id)));
  };

  // Handle row click to select/deselect
  const handleRowClick = (id) => {
    const isSelected = selected.includes(id);
    handleSelectOne(!isSelected, id);
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-5xl max-h-[80vh] overflow-auto">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold text-center">Split Shipment</DialogTitle>
        </DialogHeader>
        
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="w-12">
                <Checkbox
                  checked={selected.length === shipmentItems.length}
                  onCheckedChange={handleSelectAll}
                />
              </TableHead>
              <TableHead>Image</TableHead>
              <TableHead>Title</TableHead>
              <TableHead>Quantity</TableHead>
              <TableHead>Oversized</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {shipmentItems.map((item) => (
              <TableRow
                key={item.id}
                className={`cursor-pointer ${selected.includes(item.id) ? 'bg-accent' : 'hover:bg-muted/50'}`}
                onClick={() => handleRowClick(item.id)}
              >
                <TableCell>
                  <Checkbox
                    checked={selected.includes(item.id)}
                    onCheckedChange={(checked) => handleSelectOne(checked, item.id)}
                    onClick={(e) => e.stopPropagation()}
                  />
                </TableCell>
                <TableCell>
                  <img
                    src={item.item.images?.[0]?.thumbnail_url}
                    alt={item.item.title}
                    className="w-16 h-16 object-cover rounded"
                  />
                </TableCell>
                <TableCell>
                  <div>
                    <div className="font-medium">{item.item.title}</div>
                    <div className="text-sm text-muted-foreground">
                      ASIN: {item.item.asin}, FNSKU: {item.item.fnsku}, SKU: {item.item.merchant_sku}
                    </div>
                  </div>
                </TableCell>
                <TableCell>{item.quantity}</TableCell>
                <TableCell>
                  {(() => {
                    const lengthInches = item.item.length_mm / 25.4;
                    const widthInches = item.item.width_mm / 25.4;
                    const heightInches = item.item.height_mm / 25.4;
                    const weightLbs = item.item.weight_gm / 453.592;

                    const isOversized =
                      lengthInches > 18 || widthInches > 14 || heightInches > 8 || weightLbs > 20;

                    return isOversized ? (
                      <span className="bg-yellow-400 text-black font-bold px-2 py-1 rounded text-xs">
                        Yes
                      </span>
                    ) : (
                      <span className="bg-muted text-muted-foreground px-2 py-1 rounded text-xs">No</span>
                    );
                  })()}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        
        <DialogFooter className="flex justify-end gap-4">
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={onSplit}>
            Split Shipment
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default SplitShipmentModal;